export default "__VITE_ASSET__335d6fb2__"